import React, { ReactNode } from 'react'

import Button from '../Button/Button'

import CustomModal from './CustomModal'

export type PrimaryModalButtonListButton = {
  id: string
  label: string
  type?: 'primary' | 'secondary' | 'danger' | 'success'
  onClick: () => void
  isDisabled?: boolean
  isLoading?: boolean
}

interface PrimaryModalProps {
  buttonList?: Array<PrimaryModalButtonListButton>
  disableOutsideClick?: boolean
  modalIcon?: ReactNode
  modalText: ReactNode
  modalTitle?: ReactNode
  modalWidth?: string
  setShowModal: (showModal: boolean) => void
  showModal: boolean
}

const PrimaryModal: React.FC<PrimaryModalProps> = ({
  buttonList = [],
  disableOutsideClick = false,
  modalIcon,
  modalText,
  modalTitle,
  modalWidth,
  setShowModal,
  showModal,
}) => {
  return (
    <CustomModal
      disableOutsideClick={disableOutsideClick}
      icon={modalIcon}
      modalWidth={modalWidth}
      setShowModal={setShowModal}
      showModal={showModal}
      title={modalTitle}
    >
      <span>{modalText}</span>
      <div className="mt-5 grid gap-3">
        {buttonList?.length &&
          buttonList.map((button) => (
            <Button
              key={button.id}
              title={button.label}
              // TODO: Make this more flexible -- do not define specific types.
              customButtonClass={`${
                button.type === 'primary'
                  ? 'bg-blue-700 hover-bg-blue-800'
                  : button.type === 'secondary'
                    ? 'bg-gray-700 hover:bg-gray-800'
                    : button.type === 'success'
                      ? 'bg-green-700 hover:bg-green-800'
                      : button.type === 'danger'
                        ? 'bg-red-700 hover:bg-red-800'
                        : 'bg-red-700 hover:bg-red-800'
              } text-white hover:text-white`}
              onClick={button.onClick}
              isDisabled={button.isDisabled}
              isLoading={button.isLoading}
            />
          ))}
      </div>
    </CustomModal>
  )
}

export default PrimaryModal
